import React, {useState, useEffect} from 'react';
import * as S from './style';
import {firstProps, secondProps, thirdProps, invalidProps} from './data';
import {CardContent, SelectTable} from '../../../Components/Organism';
import {BreadCrumb, PersonForm} from '../../../Components/Template';
import {setForm, setWarnText} from '../../../util';
import {Button, Container} from '../../../Components/Atom';
import {isValidate} from '../../../util/validator';
import {
	getListPersonParticipation,
	updatePersonParticipation,
} from '../../../api';
import {initialInfo} from '../UpdateVolunteer/data';
import {TopWRapper} from '../Person';
import {thirdProgress} from '../../../config/images';
import {useDaumPostcodePopup} from 'react-daum-postcode';
import styled from 'styled-components';
import {colorPalette} from '../../../config';

const setData = ({state, setState, data}) => {
	let person = data[0];
	let participation = person.participation;

	secondProps.info.map((info) => {
		info.forEach((item) => {
			switch (item.key) {
				case 'name':
					item.content.children = participation.name;
					break;
				case 'course':
					item.content.children = `${participation.course} ${participation.gender}부`;
					break;
				case 'gift':
					item.content.children = participation.gift;
					break;
				case 'depositor':
					item.content.children = person.depositor;
					break;
				case 'address':
					item.content.children = `${person.address} ${person.detail_address}`;
					break;
				case 'birth':
					item.content.children = `${participation.birth}`;
					break;
				case 'email':
					item.content.children = person.email;
					break;
				case 'phone':
					item.content.children = participation.phone;
					break;
				default:
					break;
			}
		});
	});

	let splitted_birth = participation.birth.split('-');
	let splitted_phone = participation.phone.split('-');
	if (participation.option && participation.gift == '티셔츠') {
		participation.gift = `${participation.gift} - ${participation.option}`;
	}
	setState({
		...participation,
		...person,
		year: splitted_birth[0],
		month: splitted_birth[1],
		day: splitted_birth[2],
		phone1: splitted_phone[0],
		phone2: splitted_phone[1] ? splitted_phone[1] : '',
		phone3: splitted_phone[2] ? splitted_phone[2] : '',
		email: person.email ? person.email : '',
	});
	secondProps.fee.items[0][0].content.children =
		person.deposit_amount == '0' ? '-' : person.deposit_amount + '원';
	secondProps.fee.items[0][1].content.children = participation.is_deposit
		? '입금'
		: '미입금';
	secondProps.tabletFee.items[0][0].content.children =
		person.deposit_amount == '0' ? '-' : person.deposit_amount + '원';
	secondProps.tabletFee.items[0][1].content.children =
		participation.is_deposit ? '입금' : '미입금';
};

const UpdatePerson = () => {
	const [info, setInfo] = useState({
		name: '',
		phone1: '',
		phone2: '',
		phone3: '',
		year: '',
		month: '',
		day: '',
		gender: '',
		post_number: '',
		address: '',
		detail_address: '',
		email: '',
		depositor: '',
		course: '',
		gift: '',
		option: '',
		password: '',
	});
	const [invalid, setInvalid] = useState(invalidProps);
	const [section, setSection] = useState(0);
	const open = useDaumPostcodePopup();

	const handleComplete = (data) => {
		let post_number = data.zonecode;
		let address = data.address;

		setInfo({
			...info,
			post_number,
			address,
		});
	};

	const handleClick = () => {
		open({onComplete: handleComplete});
	};

	useEffect(() => {
		(async () => {
			let name = sessionStorage.getItem('name');
			let birth = sessionStorage.getItem('birth');
			let password = sessionStorage.getItem('password');

			if (!name && !birth && !password) {
				return;
			}
			let res = await getListPersonParticipation({name, birth, password});
			if (!res.isSuccess) {
			}
			let birthSplitted = birth.split('-');
			if (res.data.count === 1) {
				setInfo({
					...info,
					name: name,
					year: birthSplitted[0],
					month: birthSplitted[1],
					day: birthSplitted[2],
					password: password,
				});
				setData({
					state: info,
					setState: setInfo,
					data: res.data.results,
				});
				sessionStorage.removeItem('name');
				sessionStorage.removeItem('birth');
				sessionStorage.removeItem('password');
				setSection(1);
			}
		})();

		return () => {};
	}, []);

	const firstInfo = {
		name: info.name,
		year: info.year,
		month: info.month,
		day: info.day,
		password: info.password,
	};
	firstProps.inputs.forEach((input) => {
		setForm(input, info, setInfo);
		setWarnText(input, invalid);
	});

	thirdProps.inputs.forEach((input) => {
		if (document.getElementsByName('post_number')[0]) {
			if (input.name == 'post_number') {
				document.getElementsByName('post_number')[0].readOnly = true;
			}
			if (input.name == 'address') {
				document.getElementsByName('address')[0].readOnly = true;
			}
		}
		setForm(input, info, setInfo);
		setWarnText(input, invalid);
	});
	thirdProps.inputs[4].button.onClick = () => handleClick();
	firstProps.button.onClick = async () => {
		if (isValidate(firstInfo, invalidProps, setInvalid)) {
			let res = await getListPersonParticipation({
				name: info.name,
				birth: `${info.year}-${info.month}-${info.day}`,
				password: info.password,
			});
			if (res.data.count !== 1) {
				return alert('신청서가 존재하지 않습니다.');
			}
			setData({
				state: info,
				setState: setInfo,
				data: res.data.results,
			});
			setSection(1);
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	};
	secondProps.button.onClick = () => {
		if (info.is_deposit) {
			return alert('입금확인 후에는 변경이 불가합니다.');
		}
		setSection(2);
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	thirdProps.button.onClick = async () => {
		if (info.email == '@') {
			info.email = '';
		}
		if (isValidate(info, invalidProps, setInvalid)) {
			// if (info.gift.split(' - ').length == 2) {
			// 	var gift = info.gift.split(' - ')[0];
			// 	var option = info.gift.split(' - ')[1];
			// } else {
			// 	gift = info.gift;
			// 	option = info.option;
			// }
			let res = await updatePersonParticipation({
				...info,
				phone: `${info.phone1}-${info.phone2}-${info.phone3}`,
				birth: `${info.year}-${info.month}-${info.day}`,
				gift: '-',
				// option: option,
			});
			if (!res.isSuccess) {
				return;
			}
			alert('신청서 수정이 완료되었습니다.');
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
			setSection(0);
			setInfo(initialInfo);
		}
	};

	return (
		<Container>
			<TopWRapper>
				<BreadCrumb
					depths={[
						'HOME',
						'참가신청 하기',
						'개인 참가신청 조회/수정',
					]}
				/>
				{section === 1 && <img src={thirdProgress} />}
			</TopWRapper>

			{section === 0 && (
				<S.FirstSection>
					<InfoBox>
						정보조회를 위해 아래의 정보를 입력해 주세요.
					</InfoBox>
					<PersonForm {...firstProps} />
				</S.FirstSection>
			)}
			{section === 1 && (
				<S.SecondSection>
					<S.TableWrapper>
						<SelectTable items={secondProps.info} />
					</S.TableWrapper>
					<S.CardContentWrapper>
						<CardContent {...secondProps.cardContent} />
					</S.CardContentWrapper>
					<S.TableWrapper>
						<SelectTable {...secondProps.fee} />
						<SelectTable {...secondProps.tabletFee} />
					</S.TableWrapper>
					<S.ButtonWrapper>
						<Button {...secondProps.button} />
					</S.ButtonWrapper>
				</S.SecondSection>
			)}
			{section === 2 && (
				<S.ThirdSection>
					<PersonForm
						{...thirdProps}
						info={info}
						setInfo={setInfo}
						isInfoText={false}
					/>
				</S.ThirdSection>
			)}
		</Container>
	);
};

export default UpdatePerson;
const InfoBox = styled.div({
	padding: 17,
	background: `${colorPalette.card}`,
	borderRadius: 8,
	marginBottom: 52,
	color: `${colorPalette.white}`,
});
